var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13523 2.49219V9.13596H2.49146V2.49219H9.13523ZM7.47427 4.15314H4.15241V7.47501H7.47427V4.15314ZM9.13523 10.7969V17.4406H2.49146V10.7969H9.13523ZM7.47427 12.4578H4.15241V15.7797H7.47427V12.4578ZM17.4399 2.49219V9.13596H10.7961V2.49219H17.4399ZM15.779 4.15314H12.4571V7.47501H15.779V4.15314Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2876 10.7969H14.9485V17.4406H13.2876V10.7969Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7961 13.2891H17.4399V14.95H10.7961V13.2891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.90872bed24f9190f279f0bb1e6198285.svg";
export { ForwardRef as ReactComponent };